import { render, staticRenderFns } from "./SafeguardingMetrics.vue?vue&type=template&id=2df3e850&scoped=true&"
import script from "./SafeguardingMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SafeguardingMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SafeguardingMetrics.vue?vue&type=style&index=0&id=2df3e850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3e850",
  null
  
)

export default component.exports